<app-main-layout>
  <div [@routeAnimations]="o.isActivated ? o.activatedRoute : ''">
    <router-outlet #o="outlet"></router-outlet>
  </div>
</app-main-layout>
